var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 d-flex align-items-center part-select" },
    [
      _vm.item.imageDefault
        ? _c(
            "div",
            [
              _vm.preview
                ? _c("ProductsImagePreview", {
                    attrs: { item: _vm.item, onlyImages: true, noAssign: true },
                  })
                : _c("div", { staticClass: "part-thumbnail" }, [
                    _c("img", {
                      staticClass: "w-100 p-2",
                      attrs: {
                        src:
                          _vm.item.imageDefault.url || "/img/loading-img.png",
                      },
                    }),
                  ]),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "ml-2 d-flex justify-content-between w-100" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("h6", { staticClass: "m-0" }, [
            _vm._v("\n        " + _vm._s(_vm.item.productId) + "\n      "),
          ]),
          _vm.item.productName || _vm.item.supplierCode
            ? _c("small", [
                _vm._v(
                  _vm._s(
                    [_vm.item.productName, _vm.item.supplierCode]
                      .filter((e) => e)
                      .join(" ")
                  )
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }